import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import pluginCarousel1 from './plugin-carousel-1.png';
import pluginCarousel2 from './plugin-carousel-2.png';

const slideSettings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block"}}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block"}}
      onClick={onClick}
    />
  );
}
export const PluginDetailSlider = () => {

    return (
        <Slider  {...slideSettings}
        >
            <div>
                <img src={pluginCarousel1} className='tw-w-full'/>
            </div>
            <div>
                <img src={pluginCarousel2} className='tw-w-full'/>
            </div>
        </Slider>)
}
